import { useState, useEffect } from 'react'
import { useAuth } from './useAuth'
import { User } from '../types'

// Admin yetkilendirme hook'u
export const useAdminAuth = () => {
  const { user, loading } = useAuth()
  const [isAdmin, setIsAdmin] = useState(false)
  const [adminLoading, setAdminLoading] = useState(true)

  useEffect(() => {
    if (!loading) {
      if (user) {
        // Admin kontrolü - email bazlı veya role bazlı
        const adminEmails = [
          'admin@lgstakip.com',
          'baron@lgstakip.com',
          // Buraya admin email'leri eklenebilir
        ]
        
        const isAdminUser = 
          user.role === 'admin' || 
          (Array.isArray(user.roles) && user.roles.includes('admin')) ||
          adminEmails.includes(user.email.toLowerCase())
        
        setIsAdmin(isAdminUser)
      } else {
        setIsAdmin(false)
      }
      setAdminLoading(false)
    }
  }, [user, loading])

  return {
    isAdmin,
    user,
    loading: loading || adminLoading,
    hasAdminAccess: isAdmin && !loading && !adminLoading
  }
}

// Admin yetki kontrolü için yardımcı fonksiyon
export const checkAdminPermission = (user: User | null): boolean => {
  if (!user) return false
  
  const adminEmails = [
    'admin@lgstakip.com',
    'baron@lgstakip.com',
  ]
  
  return (
    user.role === 'admin' ||
    (Array.isArray(user.roles) && user.roles.includes('admin')) ||
    adminEmails.includes(user.email.toLowerCase())
  )
}

// Admin işlemleri için wrapper fonksiyon
export const withAdminAuth = <T extends any[], R>(
  fn: (...args: T) => Promise<R>
) => {
  return async (user: User | null, ...args: T): Promise<R> => {
    if (!checkAdminPermission(user)) {
      throw new Error('Bu işlem için admin yetkisi gereklidir')
    }
    return fn(...args)
  }
}